export function splitSearchWords(value: string | undefined): string[] | undefined {
  const words = value?.trim().split(/\s+/).filter(Boolean);
  return words?.length ? words : undefined;
}
